export enum Status {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED'
}

export type TierUpgradeRequest = {
	id: number;
	addon: 'CDH' | 'MA';
	requestedTier: number;
	currentTier: number;
	status: Status;
	regBy: number;
	regDate: string;
	handledBy: number;
	handleDate: string;
};
